import { ref, h, resolveComponent } from "vue";

const types = {
  text: "ComponentTypeText",
  number: "ComponentTypeNumber",
  select: "ComponentTypeSelect",
  toggle: "ComponentTypeToggle",
};

export default function formBuilder() {
  const components = ref([]);

  const componentePai = resolveComponent("inputsTypesGroup");

  const generateComponents = (componentArray, values = null) => {
    if (componentePai?.components === undefined) {
      return;
    }

    components.value = componentArray.map(({ type, name, props }) => {
      props.value = values[name];
      props.name = name;

      if (!componentePai?.components[types[type]]) {
        console.error(`Component ${type} not found.`);
        return null;
      }

      return h(componentePai?.components[types[type]], { ...props });
    });
  };

  return {
    components,
    generateComponents,
  };
}
